import { config } from 'src/config';

class NavigationService {
  public static readonly AUTH_CALLBACK = '/auth/callback';
  public static readonly LOGOUT = '/logout';
  public static readonly CHOOSE_ACCOUNT = '/choose-account';
  public static readonly CHOOSE_SERVICE_LOCATION = '/choose-address';
  public static readonly ERROR = '/error';
  public static readonly ERROR_NOT_AVAILABLE = '/not-available';
  public static readonly ERROR_NO_SERVICE_LOCATIONS = '/no-service-locations';
  public static readonly ERROR_HAS_INFLIGHT_ORDER = '/in-flight-order';
  public static readonly ERROR_RESTRICTED_PURCHASE = '/restricted-purchase';
  public static readonly ERROR_WRONG_ROLE = '/wrong-role';
  public static readonly ERROR_PRODUCT_NOT_AVAILABLE = '/product-not-available';
  public static readonly ERROR_SESSION_EXPIRED = '/session-expired';
  public static readonly STORE = '/store';
  public static readonly SUMMARY = `${NavigationService.STORE}/confirm`;
  public static readonly PRODUCT_DETAILS = `${NavigationService.STORE}/product-details`;
  public static readonly SUCCESS = `${NavigationService.STORE}/product/receipt`;

  public readonly goToMineSider = (): void => {
    window.location.href = config.ALTIBOX_MY_PAGES_URL;
  };

  public readonly getRedirectUri = (): string => `${document.location.origin}${NavigationService.AUTH_CALLBACK}`;

  public readonly goToMainPage = (): void => {
    window.location.href = config.MAIN_PAGE_URL;
  };
}

const navigationService = new NavigationService();

export { navigationService, NavigationService };
